module.exports = __webpack_public_path__ + "img/403.f5253cf9.svg";